module.exports = __webpack_public_path__ + "media/images/new-ui-images/contact-icon-6f8227b460bbc9d303b1224c05e9691a.svg";